import { Component, OnInit, inject } from '@angular/core';

import { CdsOption } from '@cds/ng-core/configuration';

import { environment } from 'src/environments/environment';
import { LanguageChangeService } from '../language-change.service';
import { CdsIconModule } from '@cds/ng-web-components/icon';

@Component({
  selector: 'app-language-switch',
  templateUrl: './language-switch.component.html',
  styleUrls: ['./language-switch.component.scss'],
  imports: [CdsIconModule],
})
export class LanguageSwitchComponent implements OnInit {
  private languageChangeService = inject(LanguageChangeService);

  languages: CdsOption[] = environment.languageList;
  isShowLanguageList = false;

  changeLang(lang: string) {
    this.languageChangeService.setLang(lang);
    this.isShowLanguageList = false;
  }

  ngOnInit(): void {}

  toggle() {
    this.isShowLanguageList = !this.isShowLanguageList;
  }
}
